import { jsx } from "react/jsx-runtime";
import { forwardRef, useState, useMemo, useCallback } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import { getInitials } from "../../helpers/avatar.utils.js";
const Avatar = forwardRef((props, ref) => {
  const { src, alt, bgColor, textColor, initialsOnly = true, className, style, imgProps = {}, ...rest } = props;
  const { className: imgClassName, onError, ...restProps } = imgProps;
  const [isError, setIsError] = useState(false);
  const showImage = useMemo(() => src && !isError, [isError, src]);
  const renderAlt = useCallback(() => {
    if (initialsOnly)
      return getInitials(alt);
    return alt;
  }, [alt, initialsOnly]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      ref,
      className: twMerge(
        "relative flex items-center justify-center flex-shrink-0 select-none rounded-full overflow-hidden text-center font-medium size-[2.25em] text-[var(--avatar-color)] bg-[var(--avatar-background-color)]",
        className
      ),
      style: {
        backgroundColor: bgColor,
        color: textColor,
        ...style
      },
      children: showImage ? /* @__PURE__ */ jsx(
        "img",
        {
          ...restProps,
          className: twMerge(
            "w-full h-full object-cover object-center rounded-full text-transparent",
            imgClassName
          ),
          src,
          alt,
          onError: (e) => {
            setIsError(true);
            onError == null ? void 0 : onError(e);
          }
        }
      ) : renderAlt()
    }
  );
});
export {
  Avatar as default
};
//# sourceMappingURL=Avatar.js.map
